import { createAction, props } from '@ngrx/store';

/**
 * Orbi feature-flag actions (PCSA-13165). The web AI agent is gated behind a
 * single Split.io flag so it can be enabled / disabled / rolled back per
 * environment & cohort without a code deploy. Mirrors the `moonshot` slice's
 * action shape.
 */

/**
 * Triggers evaluation of the Split flag (dispatched once the user is
 * authenticated). The orbi-feature effect resolves the treatment and dispatches
 * [setOrbiAgentEnabled].
 */
export const loadOrbiAgentFlag = createAction('[Orbi Feature] Load Agent Flag');

/** Sets whether the web AI agent experience is enabled for this user/session. */
export const setOrbiAgentEnabled = createAction(
  '[Orbi Feature] Set Agent Enabled',
  props<{ enabled: boolean }>()
);

export const OrbiFeatureActions = {
  loadOrbiAgentFlag,
  setOrbiAgentEnabled,
};
